import React from "react";
import OverviewCard from "./OverviewCard";

const Overview = () => {
  return (
    <div className="mb-5 h-100">
      <h3 className="mb-4">Overview</h3>

      <OverviewCard />
    </div>
  );
};

export default Overview;